<button class="search-btn" [ngClass]="className" type="button">
  <svg class="search-btn__icon">
    <use xlink:href="#icon-search" />
  </svg>
</button>
